import IconButton from '@material-ui/core/IconButton';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import PlusIcon from '@material-ui/icons/Add';
import ListIcon from '@material-ui/icons/List';
import React from 'react';
import { compose } from 'redux';
import { Themable, TThemableProps } from './Themable.hoc';
import { FieldProps } from 'formik';

interface IOwnProps {
    onAdd?: () => void;
    onSelect?: () => void;
}

type TProps = IOwnProps & TThemableProps & TextFieldProps & Partial<FieldProps>;

const GridSearchSelectWrapper = ({
    field,
    form,
    onSelect,
    onAdd,
    classes,
    ...props
}: TProps) => (
    <div className={classes.container}>
        <TextField
            margin="dense"
            className={classes.input}
            {...field}
            {...props}
        />
        {onSelect && (
            <IconButton onClick={onSelect} color="primary">
                <ListIcon />
            </IconButton>
        )}
        {onAdd && (
            <IconButton onClick={onAdd} color="primary">
                <PlusIcon />
            </IconButton>
        )}
    </div>
);

export default compose(Themable)(GridSearchSelectWrapper);
